import React from "react";
import { FormData } from "../types";
import { TextField } from "../../../components/ui/Field";
import { AddressSection } from "./AddressSection";

interface ContactSectionProps {
  formData: FormData;
  onEventFieldChange: (field: keyof FormData, value: string) => void;
  updateFormData: (field: keyof FormData, value: FormData[keyof FormData]) => void;
  onSameAsEventChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  validationErrors?: { [key: string]: string };
}

export const ContactSection: React.FC<ContactSectionProps> = ({
  formData,
  onEventFieldChange,
  updateFormData,
  onSameAsEventChange,
  validationErrors = {},
}) => (
  <div className="space-y-8">
    <fieldset>
      <legend className="font-display text-lg font-bold">Wie mogen we contacteren?</legend>
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <TextField
          label="Voornaam"
          name="eventVoornaam"
          autoComplete="given-name"
          value={formData.eventVoornaam}
          onValueChange={(value) => onEventFieldChange("eventVoornaam", value)}
          error={validationErrors.eventVoornaam}
        />
        <TextField
          label="Achternaam"
          name="eventNaam"
          autoComplete="family-name"
          value={formData.eventNaam}
          onValueChange={(value) => onEventFieldChange("eventNaam", value)}
          error={validationErrors.eventNaam}
        />
        <TextField
          label="E-mail"
          name="eventEmail"
          type="email"
          autoComplete="email"
          value={formData.eventEmail}
          onValueChange={(value) => onEventFieldChange("eventEmail", value)}
          error={validationErrors.eventEmail}
          hint="Hier sturen we je offerte naartoe."
        />
        <TextField
          label="Telefoon"
          name="eventPhoneNumber"
          type="tel"
          autoComplete="tel"
          value={formData.eventPhoneNumber}
          onValueChange={(value) => onEventFieldChange("eventPhoneNumber", value)}
          error={validationErrors.eventPhoneNumber}
        />
      </div>
    </fieldset>

    <fieldset>
      <legend className="font-display text-lg font-bold">Facturatie</legend>
      <label className="mt-3 flex cursor-pointer items-center gap-3 text-sm">
        <input
          type="checkbox"
          checked={formData.sameAsEvent}
          onChange={onSameAsEventChange}
          className="h-5 w-5 rounded border-bl-black/30 accent-bl-brown"
        />
        Factuur naar het adres van het event
      </label>
      {!formData.sameAsEvent && (
        <div className="step-in mt-4">
          <AddressSection type="factuur" formData={formData} onAddressChange={(field, value) => updateFormData(field, value)} validationErrors={validationErrors} />
        </div>
      )}
      <div className="mt-4 grid gap-4 sm:grid-cols-2">
        <TextField
          label="Bedrijfsnaam"
          name="bedrijfsnaam"
          optional
          autoComplete="organization"
          value={formData.bedrijfsnaam}
          onValueChange={(value) => updateFormData("bedrijfsnaam", value)}
        />
        <TextField
          label="Btw-nummer"
          name="btwnummer"
          optional
          placeholder="BE0123.456.789"
          value={formData.btwnummer}
          onValueChange={(value) => updateFormData("btwnummer", value)}
        />
      </div>
    </fieldset>
  </div>
);
